// src/styles/embed-theme.js
//
// Embed-only theme override. When Vault runs inside Tango's iframe (?embed=1),
// embedAuth.js stamps data-embed="1" on <html> and App.js mounts this. It
// remaps Vault's SEMANTIC tokens onto Tango's current palette so the embed
// reads as the same product family, and turns off Vault's wallpaper for
// Tango's flat cream. Primitives (--green-800 etc.) are untouched, so charts
// and any hardcoded literals keep their own values.
//
// Scoped to :root[data-embed="1"] — higher specificity than TokenStyles' bare
// :root, so it wins regardless of style-injection order, and is provably inert
// standalone (the attribute is only ever set in embed mode).
//
// Colors only — fonts are left as Vault's own (--font-body/heading/title
// unchanged) on purpose: the embed matches Tango's palette, not its typeface.

import { createGlobalStyle } from 'styled-components';

const EmbedTheme = createGlobalStyle`
  :root[data-embed="1"] {
    --color-app-bg: #faf7f1;
    --color-surface-glass: #ffffff;
    --color-brand: #c2410c;
    --color-brand-hover: #9a3412;
    --color-accent: #c2410c;
    --color-accent-soft: #fff4e8;
    --color-text: #1a1714;
    --color-text-secondary: #4a443c;
    --color-text-muted: #8a8275;
    --color-border: #e6dfce;
    --color-divider: #efe9d8;
    --color-danger: #991b1b;
    --color-danger-text: #991b1b;
    --color-success: #3f6b22;
    --color-link-hover: #c2410c;
    --color-focus-ring: rgba(194, 65, 12, 0.45);
  }

  :root[data-embed="1"] body {
    background-image: none;
    background-color: #faf7f1;
  }
`;

export default EmbedTheme;
